import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="min-h-screen bg-[#0b0b0f] text-white flex flex-col">
      {/* ─────────── HEADER ─────────── */}
      <header className="border-b border-white/10 bg-[#0b0b0f]/70 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold">
            Ovylon
            <span className="text-sm text-gray-400 font-medium ml-2">AI Studio</span>
          </Link>

          <div className="flex gap-3">
            <Link
              to="/register"
              className="px-4 py-2 bg-white text-black rounded-lg font-semibold hover:bg-gray-200 transition"
            >
              Crear cuenta
            </Link>
            <Link
              to="/login"
              className="px-4 py-2 border border-white/15 rounded-lg hover:bg-white/10 transition"
            >
              Iniciar sesión
            </Link>
          </div>
        </div>
      </header>

      {/* ─────────── CONTENT ─────────── */}
      <main className="flex-1 max-w-6xl mx-auto px-6 py-16">
        <div className="text-xs uppercase tracking-[0.25em] text-gray-400">
          Qué es Ovylon
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mt-3 max-w-4xl">
          Un estudio creativo con IA, listo para negocio.
        </h1>

        <p className="text-gray-400 mt-5 text-lg max-w-3xl leading-relaxed">
          Ovylon no es “otra app para generar imágenes”.
          Es un sistema de creación que transforma un brief en piezas visuales
          coherentes, reutilizables y listas para publicar, sin improvisación ni
          trabajo manual innecesario.
        </p>

        {/* ─────────── 3 PILLARS ─────────── */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-8 min-h-[190px]">
            <div className="text-base font-semibold mb-3">
              Qué problema resuelve
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Crear contenido uno por uno es lento y caótico: repetir prompts,
              probar variaciones al azar y obtener resultados inconsistentes.
              Ovylon convierte ese caos en flujos claros y repetibles, pensados
              para producción real.
            </p>
            <p className="text-xs text-gray-400 mt-3">
              Menos retrabajo · Más velocidad · Coherencia visual
            </p>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-8 min-h-[190px]">
            <div className="text-base font-semibold mb-3">
              Para quién es
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Para creadores, freelancers, marcas y equipos que necesitan producir
              contenido visual profesional de forma constante, rápida y escalable,
              sin perder identidad ni calidad.
            </p>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-8 min-h-[190px]">
            <div className="text-base font-semibold mb-3">
              Qué NO es
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              No es una herramienta para “jugar con prompts” ni un generador aislado.
              Ovylon está diseñado para campañas, clientes y flujos reales
              de negocio donde la consistencia importa.
            </p>
          </div>
        </div>

        {/* ─────────── CTA (solo crear cuenta, centrado) ─────────── */}
        <div className="mt-16 rounded-2xl border border-indigo-400/20 bg-gradient-to-br from-indigo-500/15 to-purple-500/10 p-10 text-center">
          <div className="text-xl font-semibold text-gray-100">
            Empieza a crear con Ovylon
          </div>
          <p className="text-sm text-gray-300 mt-3 max-w-2xl mx-auto">
            Crea tu cuenta gratuita y empieza a generar piezas visuales coherentes
            en minutos, sin configuración compleja ni curva innecesaria.
          </p>

          <div className="mt-6">
            <Link
              to="/register"
              className="inline-flex px-8 py-4 bg-white text-black rounded-xl font-semibold hover:bg-gray-200 transition"
            >
              Crear cuenta gratis →
            </Link>
          </div>
        </div>

        {/* ─────────── Volver al inicio (uniforme con Support) ─────────── */}
        <div className="mt-12 text-center">
          <Link to="/" className="text-sm text-gray-400 hover:text-white transition">
            ← Volver al inicio
          </Link>
        </div>
      </main>

      {/* ─────────── FOOTER ─────────── */}
      <footer className="border-t border-white/10 py-10 text-sm text-gray-500">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            © {new Date().getFullYear()} Ovylon® — All rights reserved.
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/about" className="hover:text-gray-300 transition">
              Qué es Ovylon
            </Link>
            <Link to="/support" className="hover:text-gray-300 transition">
              Soporte
            </Link>
            <Link to="/privacy" className="hover:text-gray-300 transition">
              Privacidad
            </Link>
            <Link to="/terms" className="hover:text-gray-300 transition">
              Términos
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
